import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae953d4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-md-12 px-1 py-3 border-bottom"
}
const _hoisted_2 = { class: "row securities_transactions mt-4 px-3" }
const _hoisted_3 = { class: "col-md-12 table-responsive" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-grey text-center font-weight-bold" }, "Investors", -1))
const _hoisted_5 = {
  id: "exA",
  class: "table table-striped table-bordered nowrap w-100"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Investor"),
    /*#__PURE__*/_createElementVNode("th", null, "Date Invested"),
    /*#__PURE__*/_createElementVNode("th", null, "Investment Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Principle Paid"),
    /*#__PURE__*/_createElementVNode("th", null, "Maturity Date")
  ])
], -1))
const _hoisted_7 = ["data-investorId", "id"]
const _hoisted_8 = { class: "exA" }
const _hoisted_9 = { class: "desc_td" }
const _hoisted_10 = { class: "exA" }
const _hoisted_11 = { class: "exA" }
const _hoisted_12 = { class: "exA" }
const _hoisted_13 = { class: "col-md-12 table-responsive" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-grey text-center font-weight-bold" }, "Coupons", -1))
const _hoisted_15 = {
  id: "exA",
  class: "table table-striped table-bordered nowrap w-100"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Date Due"),
    /*#__PURE__*/_createElementVNode("th", null, "Coupon Amount Due"),
    /*#__PURE__*/_createElementVNode("th", null, "Paid"),
    /*#__PURE__*/_createElementVNode("th", null, "Balance")
  ])
], -1))
const _hoisted_17 = { class: "exA" }
const _hoisted_18 = { class: "desc_td" }
const _hoisted_19 = { class: "exA" }
const _hoisted_20 = { class: "exA" }
const _hoisted_21 = { class: "exA" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!

  return (_ctx.fum_id!='')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_basic, { fum_id: _ctx.fum_id }, null, 8, ["fum_id"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("table", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investors, (investor) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "main_securities",
                    key: investor.investor_id,
                    "data-investorId": investor.investor_id,
                    id: 'investor_'+investor.investor_id
                  }, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(typeof investor.user_type!='undefined' && investor.user_type==1 ? investor.user_first_name+' '+investor.user_last_name : investor.user_company_name), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(investor.investor_request_date), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(typeof investor.investor_inv_amount!='undefined' ? investor.currency_symbol+' '+investor.investor_inv_amount : ''), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(typeof investor.principle_paid!='undefined' ? investor.currency_symbol+' '+investor.principle_paid : ''), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(typeof investor.myinvestment_maturity_date!='undefined' ? investor.myinvestment_maturity_date : ''), 1)
                  ], 8, _hoisted_7))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("table", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coupons, (coupon) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "main_securities",
                    key: coupon.index
                  }, [
                    _createElementVNode("td", _hoisted_17, _toDisplayString(typeof coupon['investor_name']!='undefined' ? 'Coupons Due For - '+coupon['investor_name'] : ''), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(typeof coupon['coupon_date']!='undefined' ?  coupon['coupon_date'] : ''), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(typeof coupon['total_coupon_amount']!='undefined' ?  coupon['currency_symbol']+' '+coupon['total_coupon_amount'] : ''), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(typeof coupon['paid_coupon_amount']!='undefined' ?  coupon['currency_symbol']+' '+coupon['paid_coupon_amount'] : ''), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(typeof coupon['pending_coupon_amount']!='undefined' ?  coupon['currency_symbol']+' '+coupon['pending_coupon_amount'] : ''), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}